module.exports = __webpack_public_path__ + "static/media/bg.e34beb3c.png";